import { Box, Header } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import { getDesignToken, primitive } from 'styles/constants';
import { isWeb } from 'utils/environment';

// Original styling bumped these texts up one step on web only. Preserved here.
const WEB_FONT_SIZE_OVERRIDE = isWeb ? 'sm' : undefined;

export const TransformedHeadline = Header.withConfig({
  variant: 'headerTwo',
  textAlign: 'left',
  marginX: '0',
  marginTop: '0',
  marginBottom: '4',
});

export const SentEmailText = withTypography({
  variant: 'copyOne',
  color: getDesignToken('text-default'),
  fontSize: WEB_FONT_SIZE_OVERRIDE,
});

export const CodeSentText = withTypography({
  mx: '$0',
  variant: 'copyOne',
  textAlign: 'left',
  style: { marginVertical: 3 },
});

export const ErrorMessage = withTypography({
  color: primitive.$error,
  mt: '$2',
  mx: '$0',
  variant: 'copyTwo',
  accessibilityRole: 'alert',
  style: { marginBottom: 6 },
});

export const NotReceived = Box.withConfig({
  margin: '$0',
  textAlign: 'center',
  flexWrap: 'wrap',
  justifyContent: 'center',
  flexDirection: 'row',
  _web: {
    marginTop: '$2',
  },
});

export const CodeText = withTypography({
  m: '$0',
  pt: '$0',
  variant: 'copyTwo',
  fontSize: WEB_FONT_SIZE_OVERRIDE,
  style: { paddingHorizontal: 1, paddingBottom: 1.25 },
});

export const PressableTextWrapper = withTypography({
  m: '$0',
  variant: 'copyTwo',
  color: getDesignToken('text-default'),
  bold: true,
  fontSize: WEB_FONT_SIZE_OVERRIDE,
  style: { textDecorationLine: 'underline' },
});
